import React, { useEffect, useContext, useState } from 'react'
import { LanguageContext } from '../Language/LanguageContext'
import { HeaderTitle, Loading, TablePagination } from '../Library'
import { faBox, faEnvelope, faClock, faQuestionCircle, faCheckCircle, faTimesCircle, faTruck } from '@fortawesome/free-solid-svg-icons'
import './Delivery.css'
import { setDocumentTitle } from '../AppTitle'
import { Button, Table, Form, Row, Col } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { listAllAdmin } from '../Network/Delivery'
import { listCompany } from '../Network/Company'
import { deliveryStatus, deliveryType } from './DeliveryStatusConstant'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function Delivery() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.delivery
    const history = useHistory()

    const [isLoading, setIsLoading] = useState(false)
    const [page, setPage] = useState(1)
    const [size, setSize] = useState(10)
    const [count, setCount] = useState(0)
    const [deliveryList, setDeliveryList] = useState([])

    const typeOptions = [
        { value: "", label: lang.all },
        { value: deliveryType.PARCEL, label: lang.parcel },
        { value: deliveryType.MAIL, label: lang.mail }
    ]
    const statusOptions = [
        { value: "", label: lang.all },
        { value: deliveryStatus.DELIVERED, label: lang.delivered },
        { value: deliveryStatus.COMPLETE, label: lang.complete },
        { value: deliveryStatus.CANCELLED, label: lang.cancel }
    ]
    const [companyList, setCompanyList] = useState([])

    const [type, setType] = useState("")
    const [status, setStatus] = useState("")
    const [companyId, setCompanyId] = useState("")
    const [searchKeyword, setSearchKeyword] = useState("")

    const DeliveryRecord = ({ id, trackingNo, sender, companyReceive, status, type }) => {
        let iconType
        let iconStatus

        switch (type) {
            case deliveryType.PARCEL:
                iconType = { icon: faBox, color: 'brown' }
                break;
            case deliveryType.MAIL:
                iconType = { icon: faEnvelope, color: '#10B0F6' }
                break
            default:
                iconType = { icon: faQuestionCircle, color: 'grey' }
                break;
        }

        switch (status) {
            case deliveryStatus.WAITING:
                iconStatus = { icon: faClock, color: 'orange', text: lang.waiting }
                break;
            case deliveryStatus.DELIVERED:
                iconStatus = { icon: faClock, color: 'rgb(58, 136, 188)', text: lang.delivered }
                break
            case deliveryStatus.COMPLETE:
                iconStatus = { icon: faCheckCircle, color: 'green', text: lang.complete }
                break
            case deliveryStatus.CANCELLED:
                iconStatus = { icon: faTimesCircle, color: 'red', text: lang.cancel }
                break
            default:
                iconStatus = { icon: faQuestionCircle, color: 'grey', text: lang.no_status }
                break;
        }

        return(
            <tr>
                <td style={{ fontSize: 18, width: 100 }}>
                    <FontAwesomeIcon icon={iconType.icon} color={iconType.color}/>
                    <FontAwesomeIcon icon={iconStatus.icon} color={iconStatus.color} style={{ marginLeft: 13 }}/>
                </td>
                <td>{trackingNo}</td>
                <td>{sender}</td>
                <td>{companyReceive}</td>
                <td>{iconStatus.text}</td>
                <td style={{ width: 150 }}>
                    <Button 
                    size="sm" 
                    onClick={(e)=>{
                        history.push(`delivery/view/${id}`)
                    }}>
                        {lang.see_detail}
                    </Button>
                </td>
            </tr>
        )
    }

    const clearFilter = () => {
        setCompanyId("")
        setStatus("")
        setType("")
        setSearchKeyword("")
    }

    const onSearchType = (e) => {
        const text = e.target.value
        setSearchKeyword(text)
    }

    useEffect(()=>{
        const fetchData = () => {
            setIsLoading(true)
            listAllAdmin(page, size, companyId, status, type, searchKeyword,
                (data)=>{
                    const content = data.content
                    const count = data.count
                    setCount(count)
                    setDeliveryList(content)
                    setIsLoading(false)
                },
                (error)=>{
                    setIsLoading(false)
                })
        }
        const fetchCompany = () => {
            listCompany(
                (data) => {
                    setCompanyList(data)
                },
                (error) => {  }
            )
        }
        setDocumentTitle("Delivery")
        fetchData()
        fetchCompany()
    },[page, size, companyId, status, type, searchKeyword])

    return(
        <div>
            { isLoading ? <Loading/>: null }
            <HeaderTitle 
            title={lang.parcel_management}
            customRight={
                <Form.Control 
                type="search"
                placeholder={lang.search_by_tracking_no}
                value={searchKeyword}
                onChange={onSearchType}
                />
            }
            />
            <Row>
                <Col md={6} lg={4}>
                    <Form.Group>
                        <Form.Label>{lang.company}</Form.Label>
                        <Form.Control 
                        as="select"
                        value={companyId}
                        onChange={(e) => setCompanyId(e.target.value)}>
                            <option value="">{lang.select_company}</option>
                            { companyList.map((item, key) =>
                            <option value={item.id} key={key}>{item.name}</option>
                            )}
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col md={6} lg={4}>
                    <Form.Group>
                        <Form.Label>{lang.status}</Form.Label>
                        <Form.Control 
                        as="select"
                        value={status}
                        onChange={(e)=>setStatus(e.target.value)}
                        >
                            { statusOptions.map((item, key) =>
                            <option value={item.value} key={key}>{item.label}</option>
                            )}
                        </Form.Control>
                    </Form.Group>
                </Col>
                <Col md={6} lg={4}>
                    <Form.Group>
                        <Form.Label>{lang.type}</Form.Label>
                        <Form.Control 
                        as="select"
                        value={type}
                        onChange={(e)=>setType(e.target.value)}
                        >
                            { typeOptions.map((item, key) =>
                            <option value={item.value} key={key}>{item.label}</option>
                            )}
                        </Form.Control>
                    </Form.Group>
                </Col>
            </Row>
            <Button onClick={()=>history.push('/delivery/create')}>
                {lang.add_parcel}
            </Button>
            <Button 
            variant="secondary"
            style={{ marginLeft: 13 }}
            onClick={()=>clearFilter()} >
                {lang.clear}
            </Button>

            <div className='table-content'>
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{lang.tracking_no}</th>
                            <th>{lang.sender}</th>
                            <th>{lang.company_receive}</th>
                            <th>{lang.status}</th>
                            <th>{lang.action}</th>
                        </tr>
                    </thead>
                    <tbody>
                        { deliveryList.map((item, key) =>
                        <DeliveryRecord
                        key={key}
                        id={item.id}
                        trackingNo={item.trackingNo}
                        sender={item.senderName}
                        companyReceive={item.company.name}
                        status={item.status}
                        type={item.type}
                        />
                        )}
                        { deliveryList.length === 0 ?
                        <tr>
                            <td colSpan={6} style={{ textAlign: 'center' }}>
                                {lang.no_delivery_list}
                            </td>
                        </tr>
                        : null
                        }
                    </tbody>
                </Table>
            </div>
            <div>
                <TablePagination
                dataLength={Math.ceil(count / size)}
                currentPage={page}
                size={size}
                handlerPaginationClick={(page)=>setPage(page)}
                prevClick={()=>setPage(page - 1)}
                nextClick={()=>setPage(page + 1)}
                firstPageClick={(page)=>setPage(page)}
                lastPageClick={(page)=>setPage(page)}
                disabledPrev={page === 1}
                disabledNext={page === Math.ceil(count / size)}
                />
            </div>
        </div>
    )
}


export default Delivery
